import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string, number } from 'prop-types'

const Svg = styled.svg`
	&:hover {
		circle {
			fill: ${({ hoverBackgroundColor }) => (hoverBackgroundColor ? hoverBackgroundColor : 'transparent')};
		}
		path {
			fill: ${({ hoverColor }) => hoverColor};
			stroke: ${({ hoverColor }) => hoverColor};
		}
	}
`

export const Twitter = memo(({ height = 30, variant = 'primary', width = 30 }) => {
	const {
		colors,
		socialProfileSvgs: { inverse, neutral, primary },
	} = useTheme()
	let backgroundColor = 'transparent'
	let fillColor = colors.secondary
	let hoverBackgroundColor = 'transparent'
	let hoverColor = colors.tertiary

	switch (variant) {
		case 'neutral':
			backgroundColor = neutral.backgroundColor
			fillColor = neutral.fillColor
			hoverBackgroundColor = neutral.hoverBackgroundColor
			hoverColor = neutral.hoverFillColor
			break
		case 'inverse':
			fillColor = inverse.fillColor
			hoverColor = inverse.hoverFillColor
			break
		case 'primary':
		default:
			fillColor = primary.fillColor
			hoverColor = primary.hoverFillColor
			break
	}
	return (
		<Svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 26.1 26.1"
			style={{ enableBackground: 'new 0 0 26.1 26.1' }}
			xmlSpace="preserve"
			hoverColor={hoverColor}
			hoverBackgroundColor={hoverBackgroundColor}
		>
			<circle id="top" cx={13.1} cy={13.1} r={13.1} fill={backgroundColor} />
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M11.1,18.6c-1.4,0-2.7-0.4-3.9-1.1C7,17.4,6.9,17.1,7,16.9s0.3-0.4,0.6-0.3c0.7,0.1,1.4,0,2.1-0.3
				c-0.7-0.4-1.1-0.9-1.4-1.6c0-0.1,0-0.3,0.1-0.4c-0.6-0.5-0.9-1.3-0.9-2.1c0-0.2,0.1-0.4,0.3-0.5l0,0c-0.2-0.4-0.3-0.8-0.3-1.2
				c0-0.5,0.2-1,0.4-1.4C8,8.8,8.4,8.7,8.6,8.8c0.1,0,0.1,0.1,0.1,0.1c1,1.2,2.3,2,3.9,2.2c0-1.6,1.3-2.8,2.9-2.8
				c0.7,0,1.3,0.2,1.9,0.7c0.4-0.1,0.7-0.3,1.1-0.4c0.2-0.1,0.4-0.1,0.6,0s0.2,0.4,0.2,0.6c0,0.1-0.1,0.2-0.1,0.3
				c0.1,0,0.2,0.1,0.3,0.2c0.1,0.2,0.1,0.4,0,0.6c-0.3,0.4-0.7,0.8-1.1,1.2v0.1c0,3.9-3.1,7.2-7.1,7.2C11.2,18.6,11.2,18.6,11.1,18.6z
				M9.6,17.4c3.3,0.9,6.6-1.1,7.5-4.4c0.1-0.5,0.2-1.1,0.2-1.6v-0.3c0-0.1,0-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3
				c-0.1-0.1-0.1-0.3,0-0.4c-0.1,0-0.3-0.1-0.4-0.2C16,9.1,14.8,9,14.1,9.7c-0.4,0.3-0.6,0.8-0.6,1.3c0,0.1,0,0.3,0,0.4
				c0,0.2,0,0.3-0.1,0.4C13.3,11.9,13.1,12,13,12c-1.7-0.1-3.4-0.8-4.6-2c0,0.1,0,0.1,0,0.2c0,0.6,0.3,1.2,0.8,1.5
				c0.2,0.1,0.3,0.4,0.2,0.6c-0.1,0.2-0.3,0.4-0.5,0.4H8.6c0.3,0.5,0.7,0.9,1.3,1c0.3,0.1,0.4,0.4,0.4,0.6c0,0.2-0.2,0.3-0.4,0.4
				L9.7,15c0.3,0.4,0.8,0.6,1.3,0.6c0.2,0,0.4,0.1,0.5,0.4c0.1,0.2,0,0.4-0.2,0.6C10.8,16.9,10.2,17.2,9.6,17.4z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M13,26.1c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13C26,20.2,20.2,26,13,26.1z M13,1C6.4,1,1,6.4,1,13
				s5.4,12,12,12s12-5.4,12-12S19.6,1,13,1z"
			/>
		</Svg>
	)
})

Twitter.propTypes = {
	color: string,
	height: number,
	width: number,
}
